import React from 'react';
import { useForm } from 'react-hook-form';
import styles from './ContactModal.module.scss';
import {
  ErrorField, InputEmail, InputFormatPattern, InputText,
} from '~/lib/HooksFormFields';

const ContactModal = ({
  defaultValues = {

  },
  onSubmit,
} : {
  defaultValues?: any,
  onSubmit: (value: any) => void
}) => {
  const {
    control,
    handleSubmit,
    formState: {
      errors,
    },
  } = useForm({
    defaultValues,
  });
  return (
    <div className={styles.contact}>
      <div className={styles.containerField}>
        <InputText
          label="Prénom"
          name='firstName'
          control={control}
        />
      </div>
      <div className={styles.containerField}>
        <InputText
          label="Nom"
          name='lastName'
          control={control}
        />
      </div>
      <div className={styles.containerField}>
        <InputFormatPattern
          name="phone"
          label="Téléphone"
          control={control}
          format="## ## ## ## ##"
          rules={{
            pattern: {
              value: /^(?:\s*\d){10}$/,
              message: "Le champs de numéro de téléphone n'est pas valide",
            },
          }}
        />
        {errors.phone?.message && (
          <ErrorField message={errors.phone.message} />
        )}
      </div>
      <div className={styles.containerField}>
        <InputEmail
          name="email"
          control={control}
          label="Adresse mail"
          placeholder='adressemail@mail.fr'
        />
        {errors.email && <ErrorField message={errors.email.message} />}
      </div>
      <div className={styles.action}>
        <button
          type="button"
          onClick={handleSubmit(onSubmit)}
        >
          {defaultValues?._id ? 'Modifier le contact' : 'Ajouter le contact'}
        </button>
      </div>
    </div>
  );
};

export default ContactModal;
